/* SalonID — Premium ontwerp (okt 2026): de bol komt uit de hoek en de
   richtingen schuiven langs, elke paar seconden tot de bezoeker zelf
   bladert (pijlen, stippen, ← →, vegen), de muis erop houdt of een
   toets erin heeft; na één ronde staat het stil. Dezelfde tijden als in
   SalonID Studio. Bij "minder beweging" staat alles stil. Het script
   staat bij elke sectie van de pagina en draait één keer. */
(function () {
  'use strict';
  if (window.sidPremium) return;
  window.sidPremium = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var AUTO_MS = 6500;
  var SLIDE_MS = 640;

  document.querySelectorAll('.sid-prem').forEach(function (el) { el.classList.remove('no-js'); });

  // De bol: een moment na de pagina vliegt hij naar het midden.
  document.querySelectorAll('[data-sid-premium-hero]').forEach(function (hero) {
    window.setTimeout(function () { hero.classList.add('is-arrived'); }, 160);
  });

  document.querySelectorAll('[data-sid-premium-dirs]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var infos = Array.prototype.slice.call(root.querySelectorAll('[data-info]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
    var position = root.querySelector('[data-position]');
    var count = slides.length;
    if (count < 2) return;
    var index = 0;
    var touched = false;
    var held = false;      // muis erop of een toets erin: even niet doorschuiven
    var inView = true;
    var rounds = 0;        // na één hele ronde stopt het vanzelf
    var timer = null;
    var clearOut = null;
    var words = {
      position: root.getAttribute('data-position-word') || 'Richting',
      of: root.getAttribute('data-of-word') || 'van'
    };

    function show(next) {
      if (next === index) return;
      var from = index;
      index = next;
      slides.forEach(function (slide, i) {
        slide.classList.remove('is-in', 'is-out');
        if (i === next) {
          slide.classList.add('is-active');
          slide.removeAttribute('inert');
          if (!reduce) slide.classList.add('is-in');
        } else {
          slide.classList.remove('is-active');
          slide.setAttribute('inert', '');
          if (i === from && !reduce) slide.classList.add('is-out');
        }
      });
      if (clearOut) window.clearTimeout(clearOut);
      clearOut = window.setTimeout(function () {
        slides[from].classList.remove('is-out');
        slides[next].classList.remove('is-in');
      }, SLIDE_MS);
      infos.forEach(function (info, i) { info.classList.toggle('is-active', i === next); });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === next ? 'true' : 'false'); });
      if (position) position.textContent = words.position + ' ' + (next + 1) + ' ' + words.of + ' ' + count;
      schedule();
    }

    function step(by) {
      touched = true;
      if (position) position.setAttribute('aria-live', 'polite');
      show((index + by + count) % count);
    }

    function schedule() {
      if (timer) window.clearTimeout(timer);
      timer = null;
      if (touched || reduce || held || !inView || rounds >= 1 || document.visibilityState === 'hidden') return;
      timer = window.setTimeout(function () {
        if (index === count - 1) rounds += 1;
        show((index + 1) % count);
      }, AUTO_MS);
    }

    root.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    root.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        touched = true;
        if (position) position.setAttribute('aria-live', 'polite');
        show(i);
      });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
    });
    root.addEventListener('mouseenter', function () { held = true; schedule(); });
    root.addEventListener('mouseleave', function () { held = false; schedule(); });
    root.addEventListener('focusin', function () { held = true; schedule(); });
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) { held = false; schedule(); }
    });
    // Vegen op een telefoon
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 48) step(dx < 0 ? 1 : -1);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.25 }).observe(root);
    }
    document.addEventListener('visibilitychange', schedule);
    schedule();
  });
})();
